var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticStyle:{"height":"100%"}},[_c('iframe',{ref:"mainIframe",staticStyle:{"width":"100%","height":"100%","margin":"auto"},attrs:{"id":"mainIframe","name":"mainIframe","src":"../../../../static/newMonitorMap.html","frameborder":"0","scrolling":"no"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c48140e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/monitoring/childComponents/iframeMap.vue
// module id = null
// module chunks = 